"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeMultiSelect = TreeMultiSelect;
var _lodash = require("lodash");
var _react = _interopRequireDefault(require("react"));
var _common = require("../../common");
var _Menu = require("../menu/Menu");
var _MenuItem = require("../menu/MenuItem");
var _MultiSelect = require("../select/MultiSelect");
var _TreeSelect = require("./TreeSelect");
var _excluded = ["expandedLevel", "handleChange", "nodes", "selectedItems"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function TreeMultiSelect(_ref) {
  var _ref$expandedLevel = _ref.expandedLevel,
    expandedLevel = _ref$expandedLevel === void 0 ? 3 : _ref$expandedLevel,
    handleChange = _ref.handleChange,
    nodes = _ref.nodes,
    selectedItems = _ref.selectedItems,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = _react.default.useState(selectedItems || []),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    internalSelectedItems = _React$useState2[0],
    setInternalSelectedItems = _React$useState2[1];
  var _React$useState3 = _react.default.useState(nodes || []),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    internalNodes = _React$useState4[0],
    setInternalNodes = _React$useState4[1];
  var defaultExpanded = _react.default.useMemo(function () {
    return expandedLevel ? (0, _lodash.map)(flatMapToDepth({
      nodes: nodes,
      maxDepth: expandedLevel,
      currentDepth: 0
    }), 'value') : [];
  }, [nodes, expandedLevel]);
  var _React$useState5 = _react.default.useState(defaultExpanded),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    internalExpanded = _React$useState6[0],
    setInternalExpanded = _React$useState6[1];
  var _React$useState7 = _react.default.useState(undefined),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    preQueryExpanded = _React$useState8[0],
    setPreQueryExpanded = _React$useState8[1];

  /**
   * We need to ensure that whenever the nodes change, we update the internal nodes
   * This is to ensure that the component reacts to changes in the nodes prop
   */
  _react.default.useEffect(function () {
    if (!nodes || nodes.length === 0) {
      setInternalNodes([]);
      setInternalExpanded([]);
      setInternalSelectedItems([]);
    } else {
      setInternalNodes(nodes);
      setInternalExpanded(defaultExpanded);

      // Filter out any selected items that are not in the new nodes
      var allItems = flatMapToDepth({
        nodes: nodes,
        maxDepth: 9,
        currentDepth: 0
      });
      setInternalSelectedItems(function (prevSelectedItems) {
        return prevSelectedItems.filter(function (selectedItem) {
          return allItems.some(function (item) {
            return item.value === selectedItem.value;
          });
        });
      });
    }
  }, [nodes, defaultExpanded]);

  /**
   * We need to ensure that whenever the selectedItems change, we update the internal selectedItems
   * This is to ensure that the component reacts to changes in the selectedItems prop
   */
  _react.default.useEffect(function () {
    if (!selectedItems || selectedItems.length === 0) {
      setInternalSelectedItems([]);
    } else {
      setInternalSelectedItems(selectedItems);
    }
  }, [selectedItems]);

  /**
   * maxDepth of 9 just indicates that we want to flatten the entire object, and we assume that 9 is enough
   */
  var items = flatMapToDepth({
    nodes: nodes,
    maxDepth: 9,
    currentDepth: 0
  });
  var checked = internalSelectedItems.map(function (item) {
    return item.value;
  });

  /**
   * We need to ensure that whenever the internalSelectedItems change, we call the handleChange function
   * This is to ensure that the parent component can react to changes in the selected items
   * We use isEqual to ensure that we only call handleChange if the selected items have actually changed
   * We sort both arrays by value to ensure that the order does not affect the comparison
   */
  _react.default.useEffect(function () {
    var areItemsEqual = (0, _lodash.isEqual)((0, _lodash.sortBy)(internalSelectedItems, 'value'), (0, _lodash.sortBy)(selectedItems || [], 'value'));
    if (handleChange && !areItemsEqual) {
      handleChange(internalSelectedItems);
    }
    // We don't need to add handleChange to the dependency array (we assume it is a stable function...)
    // and we are only using it to trigger a change when the internalSelectedItems change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [internalSelectedItems]);

  /**
   * This function is called when the user checks or unchecks an item in the tree
   * Ensure that we maintain any currently selected items that are not currently visible
   * We want this behaviour because we could have:
   * - Checked an item
   * - Filtered using a query string leading to the currently selected item now being hidden
   * - Checked a different item
   * In this case, we want to ensure that the previously checked item is still selected
   */
  function handleCheck(newChecked) {
    var newCheckedItems = items.filter(function (item) {
      return newChecked.includes(item.value);
    });
    var allItems = flatMapToDepth({
      nodes: nodes,
      maxDepth: 9,
      currentDepth: 0
    });
    var currentlyVisibleItems = flatMapToDepth({
      nodes: internalNodes,
      maxDepth: 9,
      currentDepth: 0
    });
    var notCurrentlyVisibleItems = allItems.filter(function (item1) {
      return !currentlyVisibleItems.some(function (item2) {
        return item1.value === item2.value;
      });
    });
    var internalSelectedItemsToKeep = internalSelectedItems.filter(function (item1) {
      return notCurrentlyVisibleItems.some(function (item2) {
        return item1.value === item2.value;
      });
    });
    var newItems = (0, _lodash.uniq)([].concat(_toConsumableArray(internalSelectedItemsToKeep), _toConsumableArray(newCheckedItems)));
    setInternalSelectedItems(newItems);
  }

  /**
   * We need to control the expanded state of the tree only because we need to modify it to ensure we expand all nodes
   * when the user searches for a query string.
   */
  function handleExpand(newExpanded) {
    setInternalExpanded(newExpanded);
  }

  /**
   * This replaces the default popover that usually contains a Menu with our Tree component
   * We use the component completely in controlled mode
   */
  function itemListRenderer() {
    if (!internalNodes || internalNodes.length === 0) {
      return /*#__PURE__*/_react.default.createElement(_Menu.Menu, null, /*#__PURE__*/_react.default.createElement(_MenuItem.MenuItem, {
        disabled: true,
        className: _common.Classes.TEXT_MUTED,
        text: "No results."
      }));
    }
    return /*#__PURE__*/_react.default.createElement(_TreeSelect.TreeSelect, {
      checked: checked,
      expanded: internalExpanded,
      nodes: internalNodes,
      onCheck: handleCheck,
      onExpand: handleExpand
    });
  }

  /**
   * We might not be showing all nodes due to the `expandedLevel` prop, so we need to ensure that
   * we expand all nodes that match the query string.
   * We'll reset the expanded nodes back to the default expanded nodes when the query is empty
   */
  function handleQueryChange(query) {
    if (query) {
      if (!preQueryExpanded) setPreQueryExpanded(internalExpanded);
      setInternalExpanded((0, _lodash.map)(flatMapToDepth({
        nodes: nodes,
        maxDepth: 9,
        currentDepth: 0
      }), 'value'));
      setInternalNodes(filterNodesByLabel({
        nodes: nodes,
        query: query
      }));
    } else {
      setInternalExpanded(preQueryExpanded || (0, _lodash.map)(flatMapToDepth({
        nodes: nodes,
        maxDepth: expandedLevel,
        currentDepth: 0
      }), 'value'));
      setInternalNodes(nodes);
    }
  }

  /**
   * No need to listen for changes to the selected items here, as we are handling that in the Tree component
   */
  return /*#__PURE__*/_react.default.createElement(_MultiSelect.MultiSelect, _extends({}, rest, {
    items: items,
    selectedItems: internalSelectedItems,
    itemListRenderer: itemListRenderer,
    onQueryChange: handleQueryChange
  }));
}

/**
 * A shim to help Blueprints Select play nicely with our Tree
 * Used to convert a ITreeSelectNode object to essentially an array of ISelectOption
 */
function flatMapToDepth(_ref2) {
  var nodes = _ref2.nodes,
    maxDepth = _ref2.maxDepth,
    _ref2$currentDepth = _ref2.currentDepth,
    currentDepth = _ref2$currentDepth === void 0 ? 0 : _ref2$currentDepth;
  return (0, _lodash.flatMap)(nodes, function (node) {
    var base = (0, _lodash.pick)(node, ['value', 'label']);
    if (currentDepth < maxDepth - 1 && node.children) {
      return [base].concat(_toConsumableArray(flatMapToDepth({
        nodes: node.children,
        maxDepth: maxDepth,
        currentDepth: currentDepth + 1
      })));
    }
    return [base];
  });
}

/**
 * It will return an array of ITreeSelectNode objects that match the query string
 */
function filterNodesByLabel(_ref3) {
  var nodes = _ref3.nodes,
    query = _ref3.query;
  return nodes.map(function (node) {
    return filterNode({
      node: node,
      query: query
    });
  }).filter(Boolean);
}

/**
 * Recursively filters a node and its children based on the query string.
 * If the node's label matches the query, it is returned.
 * If the node has children, it recursively filters them and returns the node with the filtered children.
 * If neither the node nor its children match the query, it returns null.
 */
function filterNode(_ref4) {
  var node = _ref4.node,
    query = _ref4.query;
  if (node.children) {
    var filteredChildren = node.children.map(function (child) {
      return filterNode({
        node: child,
        query: query
      });
    }).filter(Boolean);
    if (filteredChildren.length > 0) {
      return _objectSpread(_objectSpread({}, node), {}, {
        children: filteredChildren
      });
    }
  }
  if ((0, _lodash.toLower)(node.label).indexOf((0, _lodash.toLower)(query)) > -1) {
    return _objectSpread({}, node);
  }
  return null;
}